import { paths } from '@/types/api';
import { fetchClient } from '@/util/fetchClient';

type UpdateInquiryV2Path = paths['/v2/inquiries/{conversationId}']['patch'];

type UpdateInquiryBodyV2 = UpdateInquiryV2Path['requestBody']['content']['application/json'];

type UpdateInquiryParamsV2 = UpdateInquiryV2Path['parameters']['path'];

export async function updateInquiryV2({
  conversationId,
  state,
  onYourHonor,
}: UpdateInquiryBodyV2 & UpdateInquiryParamsV2) {
  const { data } = await fetchClient.PATCH('/v2/inquiries/{conversationId}', {
    params: {
      path: { conversationId },
    },
    body: {
      state,
      onYourHonor,
    },
  });

  return data?.data;
}
